"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_advanced_cropper_1 = require("vue-advanced-cropper");
var filters_1 = require("@/filter/filters");
var CropperImage = /** @class */ (function (_super) {
    __extends(CropperImage, _super);
    function CropperImage() {
        var _this = _super.call(this) || this;
        _this.typesMapping = {
            'image/jpeg': 'jpg',
            'image/png': 'png'
        };
        _this.imageUploadedUrl = null;
        _this.coordinates = {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        _this.stencilProperties = {
            aspectRatio: 12 / 12
        };
        _this.canvasProperties = {
            minHeight: 100,
            minWidth: 100,
            maxHeight: 200,
            maxWidth: 200,
        };
        _this.imageBase64UriEncoded = '';
        _this.file = null;
        _this.loader = false;
        _this.confirm = false;
        _this.validationError = false;
        _this.clientFilename = null;
        return _this;
    }
    CropperImage.prototype.mounted = function () {
        var _this = this;
        this.$root.$on('DEFAULT-USER-IMAGE-LOADED', function (image) {
            _this.confirm = true;
            _this.imageBase64UriEncoded = filters_1.serverMediaFile(image);
        });
    };
    CropperImage.prototype.crop = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var _a = this.$refs.cropper.getResult(), coordinates = _a.coordinates, canvas = _a.canvas;
        this.coordinates = coordinates;
        this.imageBase64UriEncoded = canvas.toDataURL();
        this.confirm = true;
        var file = this.getFileFromBase64UriEncoded();
        this.onSuccess(file);
    };
    CropperImage.prototype.getFileFromBase64UriEncoded = function () {
        var regex = new RegExp(/^data:(image\/jpeg|image\/png);base64,/);
        var matches = regex.exec(this.imageBase64UriEncoded);
        if (matches === null || matches.length !== 2) {
            throw new Error('UNKNOWN PATTERN URI');
        }
        var base64 = this.imageBase64UriEncoded.replace(regex, '');
        var byteString = atob(base64);
        var mimetype = matches[1];
        var uint8Array = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([uint8Array], { type: mimetype });
        return new File([blob], this.getFilename(mimetype), { type: mimetype });
    };
    CropperImage.prototype.getFilename = function (mimeType) {
        if (!this.typesMapping[mimeType]) {
            throw new Error("Mimetype " + mimeType + " not supported");
        }
        return "thumbnail_" + new Date().getTime().toString() + "." + this.typesMapping[mimeType];
    };
    CropperImage.prototype.cancel = function () {
        this.imageBase64UriEncoded = '';
        this.imageUploadedUrl = null;
        this.confirm = false;
        this.file = null;
        this.onCancel();
    };
    CropperImage.prototype.upload = function (event) {
        var _this = this;
        this.loader = true;
        var inputElement = event.target;
        if (inputElement.files === null || !inputElement.files.length) {
            return;
        }
        var currentFile = inputElement.files[0];
        if (!this.typesMapping[currentFile.type]) {
            this.validationError = true;
            this.cancel();
            return;
        }
        this.getBase64(currentFile).then(function (encoded) {
            _this.clientFilename = currentFile.name;
            _this.imageUploadedUrl = encoded;
            _this.loader = false;
        }, function (error) { return console.error(error); });
    };
    CropperImage.prototype.getBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (error) { return reject(error); };
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: false, type: Function })
    ], CropperImage.prototype, "onSuccess", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, type: Function })
    ], CropperImage.prototype, "onCancel", void 0);
    CropperImage = __decorate([
        vue_property_decorator_1.Component({
            name: 'CropperImage',
            components: {
                Cropper: vue_advanced_cropper_1.Cropper
            }
        })
    ], CropperImage);
    return CropperImage;
}(vue_1.default));
exports.default = CropperImage;
